import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass(["sortByOption", _ctx.isSelected && 'active']),
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.optionSelected && _ctx.optionSelected(...args)))
  }, _toDisplayString(_ctx.$t("Web.Containers.SortOrder." + _ctx.optionValue?.displayName.replace(' ', ''))), 3))
}